// src/pages/Dashboard/Clientes/hooks/useCustomerAssociates.ts
import { useState, useEffect, useCallback } from 'react';
import api from '@/utils/connector/ApiConnector';
import { useUser } from '@/utils/userContext/UserContext';

export const useCustomerAssociates = (customerId: string) => {
  const [associates, setAssociates] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const userContext = useUser();
  const token = userContext?.userData?.auth;

  const fetchAssociates = useCallback(async () => {
    if (!customerId || !token) {
      setAssociates([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response: any = await api.get(`/customer/${customerId}/associates`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = response.data ?? [];
      setAssociates(Array.isArray(data) ? data : []);
    } catch (err: any) {
      console.error('Erro ao buscar associados:', err);
      setError(err?.response?.data?.message || err.message || 'Falha ao carregar associados.');
      setAssociates([]);
    } finally {
      setLoading(false);
    }
  }, [customerId, token]);

  useEffect(() => {
    fetchAssociates();
  }, [fetchAssociates]);

  return { associates, loading, error, refetch: fetchAssociates };
};
